function SvgComponent() {
  return (
    <svg viewBox="0 0 40 40">
      <linearGradient
        id="PtC3nmzn5K~Q855MdLFzFa"
        x1="16.145"
        x2="26.377"
        y1="6.428"
        y2="20.715"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#048489" />
        <stop offset="1" stopColor="#03676a" />
      </linearGradient>
      <path
        fill="url(#PtC3nmzn5K~Q855MdLFzFa)"
        d="M23,4c-6.627,0-12,5.373-12,12s5.373,12,12,12s12-5.373,12-12S29.627,4,23,4z"
      />
      <linearGradient
        id="PtC3nmzn5K~Q855MdLFzFb"
        x1="27.122"
        x2="41.023"
        y1="18.616"
        y2="35.799"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#18939a" />
        <stop offset=".41" stopColor="#168c93" />
        <stop offset="1" stopColor="#117981" />
      </linearGradient>
      <path
        fill="url(#PtC3nmzn5K~Q855MdLFzFb)"
        d="M33.5,16C27.701,16,23,20.701,23,26.5S27.701,37,33.5,37S44,32.299,44,26.5S39.299,16,33.5,16	z"
      />
      <linearGradient id="PtC3nmzn5K~Q855MdLFzFc" x1="16" x2="32" y1="36" y2="36" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#37c6d0" />
        <stop offset="1" stopColor="#37c6d0" />
      </linearGradient>
      <path
        fill="url(#PtC3nmzn5K~Q855MdLFzFc)"
        d="M24,28c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S28.418,28,24,28z"
      />
      <path
        d="M22.319,13H11.393C11.146,13.961,11,14.962,11,16c0,6.627,5.373,12,12,12	c0.04,0,0.078-0.006,0.118-0.006c0.003,0.019,0.006,0.037,0.009,0.056C19.12,28.485,16,31.877,16,36c0,0.339,0.028,0.672,0.069,1	h6.25C24.352,37,26,35.352,26,33.319V16.681C26,14.648,24.352,13,22.319,13z"
        opacity=".05"
      />
      <path
        d="M16,36h6.213c1.724,0,3.121-1.397,3.121-3.121V16.454c0-1.724-1.397-3.121-3.121-3.121H11.308	C11.112,14.192,11,15.082,11,16c0,6.627,5.373,12,12,12c0.04,0,0.078-0.006,0.118-0.006c0.003,0.019,0.006,0.037,0.009,0.056	C19.12,28.485,16,31.877,16,36z"
        opacity=".07"
      />
      <path
        d="M22.106,13.667H11.231C11.082,14.422,11,15.201,11,16c0,6.627,5.373,12,12,12	c0.04,0,0.078-0.006,0.118-0.006c0.003,0.019,0.006,0.037,0.009,0.056c-3.677,0.4-6.6,3.291-7.057,6.95h6.037	c1.414,0,2.56-1.146,2.56-2.56V16.227C24.667,14.813,23.52,13.667,22.106,13.667z"
        opacity=".09"
      />
      <linearGradient
        id="PtC3nmzn5K~Q855MdLFzFd"
        x1="4.586"
        x2="23.414"
        y1="14.586"
        y2="33.414"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#058f92" />
        <stop offset="1" stopColor="#027074" />
      </linearGradient>
      <path
        fill="url(#PtC3nmzn5K~Q855MdLFzFd)"
        d="M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16	C24,33.105,23.105,34,22,34z"
      />
      <path
        fill="#fff"
        d="M10.432,28.75v-2.298c0.426,0.349,2.391,1.048,2.9,1.048c0.299,0,2.138,0.088,2.138-1.041	c0-1.633-5.082-1.494-5.082-4.725c0-0.536,0.066-3.059,4.133-3.059c1.041,0,2.271,0.261,2.628,0.395v2.147	c-0.176-0.12-0.89-0.718-2.496-0.718c-1.877,0-2.04,0.883-2.04,1.041c0,1.359,4.998,1.544,4.998,4.711	c0,3.172-3.614,3.074-4.177,3.074C12.857,29.325,10.814,28.942,10.432,28.75z"
      />
    </svg>
  )
}

export default SvgComponent
